import reduce from 'lodash.reduce';
import Big from 'big.js';

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function bigsum(numbers) {
  return reduce(numbers, (acc, number) => acc.plus(new Big(number)), new Big(0));
}

export function toMoney (amount) {
  return numberWithCommas((parseInt(amount, 10)/100).toFixed(2));
}



// WEBPACK FOOTER //
// ./web/utils/index.js